import { ReactNode } from 'react';

export function contentFilter(
  items: ReactNode[] | ReactNode,
  comboboxOptionName: string
) {
  let mainContent: ReactNode[] = [];
  let supportContent: ReactNode[] = [];
  const content = Array.isArray(items) ? items : [items];
  content.forEach((item) => {
    if (Object(item).type?.name === comboboxOptionName) {
      mainContent.push(item);
    } else {
      supportContent.push(item);
    }
  });
  return [mainContent, supportContent];
}

function isChildEmpty(child: ReactNode) {
  return typeof child !== 'number' && !child;
}

export function isComboboxChildrenEmpty(children: ReactNode[] | ReactNode) {
  return Array.isArray(children)
    ? children.every(isChildEmpty)
    : isChildEmpty(children);
}
